import { createAction, props } from '@ngrx/store'
import { FavouriteItemsEntity, FavouriteItemsResponse } from './favourite-items.models'
import { SlimItemEntity } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'

export const loadFavouriteItems = createAction('[FavouriteItems/API] Load FavouriteItems', (offset?: number) => ({
  offset,
}))

export const loadFavouriteItemsSuccess = createAction(
  '[FavouriteItems/API] Load FavouriteItems Success',
  props<{ response: FavouriteItemsResponse; offset: number }>(),
)

export const upsertFavouriteItems = createAction(
  '[FavouriteItems/API] Upsert FavouriteItems',
  props<{ favouriteItems: FavouriteItemsEntity[] }>(),
)

export const updateCount = createAction('[EventTicketPackages/API] Update Count', props<{ count: number }>())

export const updateOrderHash = createAction('[FavouriteItems/API] Update Order Hash', props<{ order: string }>())

export const loadFavouriteItemsFailure = createAction(
  '[FavouriteItems/API] Load FavouriteItems Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const resyncFavouriteItems = createAction('[FavouriteItems/API] Resync FavouriteItems', (offset: number) => ({
  offset,
}))

export const resyncFavouriteItemsOnScroll = createAction(
  '[FavouriteItems/API] Resync FavouriteItems On Scroll',
  (offset: number) => ({ offset }),
)

export const resyncFavouriteItemsCurrentPage = createAction('[FavouriteItems/API] Resync FavouriteItems Current Page')

export const setAllFavouriteItemsStale = createAction('[FavouriteItems/Page] Set All FavouriteItems Stale')

export const removePageFromStale = createAction(
  '[FavouriteItems/Page] Remove Page From Stale',
  props<{ page: number }>(),
)

export const startFavouriteProcess = createAction(
  '[FavouriteItems/API] Start favourite process',
  props<{
    itemUuid: string
    isFavourited: boolean
    onSuccess?: () => void
  }>(),
)

export const toggleFavourite = createAction(
  '[ActivityFeedPosts/API] Toggle favourite',
  props<{
    itemUuid: string
    isFavourited: boolean
    onSuccess?: () => void
  }>(),
)

export const createFavouriteItem = createAction(
  '[FavouriteItems/API] Create favourite item',
  props<{ itemUuid: string }>(),
)

export const createFavouriteItemSuccess = createAction(
  '[FavouriteItems/API] Create FavouriteItems Success',
  props<{ item: SlimItemEntity | ItemEntity }>(),
)

export const createFavouriteItemFailure = createAction(
  '[FavouriteItems/API] Create FavouriteItems Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteFavouriteItem = createAction(
  '[FavouriteItems/API] Delete favourite item',
  props<{ itemUuid: string }>(),
)

export const deleteFavouriteItemSuccess = createAction('[FavouriteItems/API] Delete favourite item success')

export const deleteFavouriteItemFailure = createAction(
  '[FavouriteItems/API] Delete favourite item failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateFavouriteItem = createAction(
  '[FavouriteItems/API] Update favourite item',
  props<{ update: Update<FavouriteItemsEntity> }>(),
)

export const disableFavourite = createAction('[FavouriteItems/Page] Disable favourite button')

export const enableFavourite = createAction('[FavouriteItems/Page] Enable favourite button')

export const removeFavouriteItems = createAction('[FavouriteItems/Page] Remove Favourite Items')

export const clearFavouriteItems = createAction('[FavouriteItems/Pahe] Clear Favourite Items')
